module.exports = __webpack_public_path__ + "static/media/Anxiety07a3e529.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/Anxiety.svg
// module id = 1299
// module chunks = 0